import { render, staticRenderFns } from "./AliasIdReportForm.vue?vue&type=template&id=573f76ad&scoped=true&"
import script from "./AliasIdReportForm.vue?vue&type=script&lang=js&"
export * from "./AliasIdReportForm.vue?vue&type=script&lang=js&"
import style0 from "./AliasIdReportForm.vue?vue&type=style&index=0&id=573f76ad&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573f76ad",
  null
  
)

export default component.exports